import { useEffect, useState } from 'react';
import {
  type CoCustomerTimeSeriesPoint,
  useLazyGetCoCustomerTimeSeriesQuery,
} from 'src/services/coCustomerAnalyticsService';
import { isErrorStatus } from 'src/utils/get-error-message';
import { TimeSeriesRequestParams } from 'src/pages/AnalyticsPage/AnalyticsCustomer/AnalyticsCoCustomer.types';

/**
 * Fetches the co-customer analytics time series for the given request params,
 * clearing the response on a 404 (no data for the selected range).
 */
export const useCoCustomerTimeSeries = (
  requestParams: TimeSeriesRequestParams,
  enabled: boolean,
) => {
  const [fetchTimeSeriesQuery, { data: timeSeriesData, isFetching, isError, error }] =
    useLazyGetCoCustomerTimeSeriesQuery();
  const [timeSeriesResponse, setTimeSeriesResponse] = useState<CoCustomerTimeSeriesPoint[]>([]);

  useEffect(() => {
    if (enabled && requestParams) {
      fetchTimeSeriesQuery(requestParams);
    }
  }, [enabled, requestParams]);

  useEffect(() => {
    if (isError && isErrorStatus(error, 404)) {
      setTimeSeriesResponse([]);
    }
  }, [isError, error]);

  useEffect(() => {
    setTimeSeriesResponse(timeSeriesData?.length ? timeSeriesData : []);
  }, [timeSeriesData]);

  return { timeSeriesResponse, isFetching };
};
